//PrimeReact
import { Dialog } from "primereact/dialog"
import { DateTime } from "luxon"

//Housing API and components
import myStyle from "../../../styles/housing/HousingActivities.module.css"

export default function HousingActivitiesDetail({
  activity,
  showForm,
  onHideForm,
  onDateDisplay,
  onGetAdditionalInfo,
  userList,
}) {
  const GetAdditionalInfo = () => {
    return onGetAdditionalInfo(activity)
  }

  if (!activity) {
    return <></>
  }

  const GetUser = () => {
    if (!!userList) {
      const user = userList.filter(
        (user) => user.staff_id === activity.activity.userId
      )

      if (user.length > 0) {
        return <>{`${user[0].staff_name_first} ${user[0].staff_name_last}`}</>
      }
    }

    return "Unknown staff member"
  }

  const showTimeLocal = (dateTimeUtc) => {
    if (!!dateTimeUtc) {
      const time = DateTime.fromISO(dateTimeUtc, { zone: "utc" }).toLocal()

      let timeString = `${time.toLocaleString(
        DateTime.TIME_SIMPLE
      )} ${time.toFormat("ZZZZ")}`

      return timeString
    } else {
      return "Unknown"
    }
  }

  return (
    <Dialog
      header={"Activity detail"}
      visible={showForm}
      onHide={() => {
        onHideForm()
      }}
      style={{ width: "400px" }}
    >
      <>
        <div>
          <span className={myStyle.additionalInfoHeader}>Date: </span>{" "}
          {onDateDisplay(activity)}
        </div>
        <div>
          <span className={myStyle.additionalInfoHeader}>StartTime: </span>{" "}
          {showTimeLocal(activity.activity.startTime)}
        </div>
        <div>
          <span className={myStyle.additionalInfoHeader}>EndTime: </span>{" "}
          {showTimeLocal(activity.activity.endTime)}
        </div>
        <div>
          <span className={myStyle.additionalInfoHeader}>House: </span>{" "}
          {activity.activity.house.name}
        </div>
        <div>
          <span className={myStyle.additionalInfoHeader}>Staff: </span>{" "}
          {GetUser()}
        </div>
        <div>
          <span className={myStyle.additionalInfoHeader}>Activity Type: </span>{" "}
          {activity.displayType}
        </div>
        <GetAdditionalInfo />
        <div>
          <span className={myStyle.additionalInfoHeader}>Notes: </span>{" "}
          {activity.activity.notes}
        </div>
      </>
    </Dialog>
  )
}
